import { useState } from 'react'

import ConfirmationDialog from '../../../components/ReusableComponents/ConfirmationDialog/index'
import TextInput from '../../../components/ReusableComponents/ManageHotel/TextInput/index'
import Toggle from '../../../components/ReusableComponents/Toggle/index'
import styles from './SubscriptionBonusDialog.module.scss'

const SubscriptionBonusDialog = props => {
  const [usesBonus, setUsesBonus] = useState(props.usesBonus)
  const [subscriptionBonus, setSubscriptionBonus] = useState(props.subscriptionBonus)

  return (
    <ConfirmationDialog
      title="Edit subscription bonus"
      theme="blacklist"
      positiveMessage="Save changes"
      onConfirm={() =>
        props.onSave({
          usesBonus,
          subscriptionBonus
        })
      }
      onClose={() => props.onClose()}
    >
      <div className={styles.container}>
        <div className={styles.label}>Subscription bonus</div>
        <div className={styles.value}>
          <Toggle
            label={usesBonus ? 'Enabled' : 'Disabled'}
            checked={usesBonus}
            handleChange={e => setUsesBonus(e.target.checked)}
          />
        </div>
        <TextInput
          label="Bonus description"
          disabled={!usesBonus}
          value={subscriptionBonus}
          onChange={e => setSubscriptionBonus(e.target.value)}
        />
      </div>
    </ConfirmationDialog>
  )
}

export default SubscriptionBonusDialog
